module.exports = __webpack_public_path__ + "94f93e6c98799319b6755a19126d5fea.pdf";